import { useQuery } from "react-query";
import { getEmployeeBiligual } from "../../../../../actions/Employees";

export const useEmployeeBilingual = () => {
  return useQuery("GetEmployeeBilingual", getEmployeeBiligual, {
    refetchOnWindowFocus: false,
  });

  
};